import { Alert, Button } from "@emdur/ui";
import { useState } from "react";
import { freshSignIn } from "../lib/auth";
import { errorText } from "../lib/errors";

/** A missing scope has the same one-press recovery inside a review or on the page. */
export function PermissionRefreshAction({ when }: { when?: string }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (when !== undefined && when !== "Sign in again to refresh permissions")
    return null;
  return (
    <div className="mt-3">
      <Button
        variant="primary"
        isLoading={busy}
        onPress={async () => {
          setBusy(true);
          setError("");
          try {
            await freshSignIn(
              `${window.location.pathname}${window.location.search}`,
            );
          } catch (failure) {
            setError(errorText(failure));
            setBusy(false);
          }
        }}
      >
        Sign in again
      </Button>
      {error && (
        <Alert tone="danger">
          {error}
          <p>Check your connection and try signing in again.</p>
        </Alert>
      )}
    </div>
  );
}
